/** Firebase / callable errors → plain Hebrew for the UI (no technical jargon). */
export function hebrewError(e: unknown): string {
  const code = (e as { code?: string })?.code ?? '';
  const message = (e as { message?: string })?.message ?? '';
  switch (code) {
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
    case 'auth/invalid-email':
      return 'שם המשתמש או הסיסמה שגויים';
    case 'auth/user-disabled':
      return 'המשתמש הושבת. יש לפנות למנהל המערכת';
    case 'auth/too-many-requests':
      return 'יותר מדי ניסיונות. נסו שוב בעוד כמה דקות';
    case 'auth/network-request-failed':
    case 'unavailable':
      return 'אין חיבור לרשת. בדקו את החיבור ונסו שוב';
    case 'permission-denied':
    case 'functions/permission-denied':
      return /[א-ת]/.test(message) ? message : 'אין לכם הרשאה לפעולה זו';
  }
  // Callables throw Hebrew messages on purpose (HttpsError).
  if (/[א-ת]/.test(message)) return message;
  return 'משהו השתבש. נסו שוב, ואם זה חוזר פנו למנהל המערכת';
}
